import ToolPaneWrapper from "./ToolPaneWrapper";

export default ToolPaneWrapper;



// WEBPACK FOOTER //
// ./src/components/ToolPaneWrapper/index.js